module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/EmptyStar.b7726396.svg";